export default __webpack_public_path__ + "static/media/sadIcon.cad8e374.png";